import { CommandContribution, CommandRegistry } from '@theia/core';
import { codicon, Widget } from '@theia/core/lib/browser';
import { TabBarToolbarContribution, TabBarToolbarRegistry } from '@theia/core/lib/browser/shell/tab-bar-toolbar';
import { injectable } from '@theia/core/shared/inversify';
import { FILE_NAVIGATOR_ID } from '@theia/navigator/lib/browser/navigator-widget';
import { ONLINE_PREVIEW_SHOW_LAUNCHER_EVENT } from './online-preview-host-widget';

const OPEN_PROJECTS_COMMAND = {
    id: 'lvgl.onlinePreview.openProjects',
    label: 'Projects'
} as const;

@injectable()
export class BrowserProjectsContribution implements CommandContribution, TabBarToolbarContribution {
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(OPEN_PROJECTS_COMMAND, {
            execute: (): void => {
                window.dispatchEvent(new CustomEvent(ONLINE_PREVIEW_SHOW_LAUNCHER_EVENT));
            }
        });
    }

    registerToolbarItems(toolbar: TabBarToolbarRegistry): void {
        toolbar.registerItem({
            id: OPEN_PROJECTS_COMMAND.id,
            command: OPEN_PROJECTS_COMMAND.id,
            icon: codicon('home'),
            tooltip: 'Projects',
            isVisible: (widget?: Widget): boolean => widget?.id === FILE_NAVIGATOR_ID,
            priority: 0
        });
    }
}
